var parseVersion = function(str) {
	// see webpack/lib/util/semver.js for original code
	var p=function(p){return p.split(".").map((function(p){return+p==p?+p:p}))},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = function(a, b) {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = function(range) {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = function(range, version) {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var ensureExistence = function(scopeName, key) {
	var scope = __webpack_require__.S[scopeName];
	if(!scope || !__webpack_require__.o(scope, key)) throw new Error("Shared module " + key + " doesn't exist in shared scope " + scopeName);
	return scope;
};
var findVersion = function(scope, key) {
	var versions = scope[key];
	var key = Object.keys(versions).reduce(function(a, b) {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = function(scope, key) {
	var versions = scope[key];
	return Object.keys(versions).reduce(function(a, b) {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = function(scope, key, version, requiredVersion) {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getSingleton = function(scope, scopeName, key, requiredVersion) {
	var version = findSingletonVersionKey(scope, key);
	return get(scope[key][version]);
};
var getSingletonVersion = function(scope, scopeName, key, requiredVersion) {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) typeof console !== "undefined" && console.warn && console.warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var getStrictSingletonVersion = function(scope, scopeName, key, requiredVersion) {
	var version = findSingletonVersionKey(scope, key);
	if (!satisfy(requiredVersion, version)) throw new Error(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	return get(scope[key][version]);
};
var findValidVersion = function(scope, key, requiredVersion) {
	var versions = scope[key];
	var key = Object.keys(versions).reduce(function(a, b) {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var getInvalidVersionMessage = function(scope, scopeName, key, requiredVersion) {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ") of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map(function(key) {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var getValidVersion = function(scope, scopeName, key, requiredVersion) {
	var entry = findValidVersion(scope, key, requiredVersion);
	if(entry) return get(entry);
	throw new Error(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var warnInvalidVersion = function(scope, scopeName, key, requiredVersion) {
	typeof console !== "undefined" && console.warn && console.warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion));
};
var get = function(entry) {
	entry.loaded = 1;
	return entry.get()
};
var init = function(fn) { return function(scopeName, a, b, c) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then) return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], a, b, c));
	return fn(scopeName, __webpack_require__.S[scopeName], a, b, c);
}; };

var load = /*#__PURE__*/ init(function(scopeName, scope, key) {
	ensureExistence(scopeName, key);
	return get(findVersion(scope, key));
});
var loadFallback = /*#__PURE__*/ init(function(scopeName, scope, key, fallback) {
	return scope && __webpack_require__.o(scope, key) ? get(findVersion(scope, key)) : fallback();
});
var loadVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingleton = /*#__PURE__*/ init(function(scopeName, scope, key) {
	ensureExistence(scopeName, key);
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return getValidVersion(scope, scopeName, key, version);
});
var loadStrictSingletonVersionCheck = /*#__PURE__*/ init(function(scopeName, scope, key, version) {
	ensureExistence(scopeName, key);
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var loadVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return get(findValidVersion(scope, key, version) || warnInvalidVersion(scope, scopeName, key, version) || findVersion(scope, key));
});
var loadSingletonFallback = /*#__PURE__*/ init(function(scopeName, scope, key, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingleton(scope, scopeName, key);
});
var loadSingletonVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getSingletonVersion(scope, scopeName, key, version);
});
var loadStrictVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	var entry = scope && __webpack_require__.o(scope, key) && findValidVersion(scope, key, version);
	return entry ? get(entry) : fallback();
});
var loadStrictSingletonVersionCheckFallback = /*#__PURE__*/ init(function(scopeName, scope, key, version, fallback) {
	if(!scope || !__webpack_require__.o(scope, key)) return fallback();
	return getStrictSingletonVersion(scope, scopeName, key, version);
});
var installedModules = {};
var moduleToHandlerMapping = {
	"webpack/sharing/consume/default/react/react?475e": function() { return loadSingletonVersionCheckFallback("default", "react", [4,18,2,0], function() { return __webpack_require__.e("node_modules_pnpm_react_18_2_0_node_modules_react_index_js").then(function() { return function() { return __webpack_require__("../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js"); }; }); }); },
	"webpack/sharing/consume/default/react-dom/react-dom": function() { return loadSingletonFallback("default", "react-dom", function() { return Promise.all([__webpack_require__.e("vendors-node_modules_pnpm_react-dom_18_2_0_react_18_2_0_node_modules_react-dom_index_js"), __webpack_require__.e("webpack_sharing_consume_default_react_react")]).then(function() { return function() { return __webpack_require__("../../node_modules/.pnpm/react-dom@18.2.0_react@18.2.0/node_modules/react-dom/index.js"); }; }); }); },
	"webpack/sharing/consume/default/react-router-dom/react-router-dom": function() { return loadSingletonVersionCheckFallback("default", "react-router-dom", [4,5,3,0], function() { return Promise.all([__webpack_require__.e("vendors-node_modules_pnpm_react-router-dom_5_3_0_react_18_2_0_node_modules_react-router-dom_e-57bc49"), __webpack_require__.e("webpack_sharing_consume_default_prop-types_prop-types-webpack_sharing_consume_default_prop-ty-5d2b1f")]).then(function() { return function() { return __webpack_require__("../../node_modules/.pnpm/react-router-dom@5.3.0_react@18.2.0/node_modules/react-router-dom/esm/react-router-dom.js"); }; }); }); },
	"webpack/sharing/consume/default/dayjs/dayjs": function() { return loadSingletonVersionCheckFallback("default", "dayjs", [4,1,10,6], function() { return __webpack_require__.e("node_modules_pnpm_dayjs_1_10_6_node_modules_dayjs_dayjs_min_js").then(function() { return function() { return __webpack_require__("../../node_modules/.pnpm/dayjs@1.10.6/node_modules/dayjs/dayjs.min.js"); }; }); }); },
	"webpack/sharing/consume/default/react/react?25fe": function() { return loadSingletonVersionCheckFallback("default", "react", [,[1,17],[1,16],[1,15],1,1], function() { return __webpack_require__.e("node_modules_pnpm_react_18_2_0_node_modules_react_index_js").then(function() { return function() { return __webpack_require__("../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js"); }; }); }); },
	"webpack/sharing/consume/default/react/react?e6fd": function() { return loadSingletonVersionCheckFallback("default", "react", [1,18,2,0], function() { return __webpack_require__.e("node_modules_pnpm_react_18_2_0_node_modules_react_index_js").then(function() { return function() { return __webpack_require__("../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js"); }; }); }); },
	"webpack/sharing/consume/default/react/react?4b27": function() { return loadSingletonVersionCheckFallback("default", "react", [0,15], function() { return __webpack_require__.e("node_modules_pnpm_react_18_2_0_node_modules_react_index_js").then(function() { return function() { return __webpack_require__("../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js"); }; }); }); },
	"webpack/sharing/consume/default/prop-types/prop-types?cdb3": function() { return loadSingletonVersionCheckFallback("default", "prop-types", [1,15,6,2], function() { return __webpack_require__.e("node_modules_pnpm_prop-types_15_8_1_node_modules_prop-types_index_js").then(function() { return function() { return __webpack_require__("../../node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js"); }; }); }); },
	"webpack/sharing/consume/default/react/react?9262": function() { return loadSingletonVersionCheckFallback("default", "react", [,[1,17,0,0],[1,16,0,0],[1,15,0,0],[2,0,14,0],1,1,1], function() { return __webpack_require__.e("node_modules_pnpm_react_18_2_0_node_modules_react_index_js").then(function() { return function() { return __webpack_require__("../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js"); }; }); }); },
	"webpack/sharing/consume/default/prop-types/prop-types?acfd": function() { return loadSingletonVersionCheckFallback("default", "prop-types", [1,15,0,0], function() { return __webpack_require__.e("node_modules_pnpm_prop-types_15_8_1_node_modules_prop-types_index_js").then(function() { return function() { return __webpack_require__("../../node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js"); }; }); }); },
	"webpack/sharing/consume/default/classnames/classnames": function() { return loadSingletonVersionCheckFallback("default", "classnames", [4,2,3,1], function() { return __webpack_require__.e("node_modules_pnpm_classnames_2_3_1_node_modules_classnames_index_js").then(function() { return function() { return __webpack_require__("../../node_modules/.pnpm/classnames@2.3.1/node_modules/classnames/index.js"); }; }); }); },
	"webpack/sharing/consume/default/react/react?8eed": function() { return loadSingletonVersionCheckFallback("default", "react", [,[1,16,0,0],[1,15,0,0],1], function() { return __webpack_require__.e("node_modules_pnpm_react_18_2_0_node_modules_react_index_js").then(function() { return function() { return __webpack_require__("../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js"); }; }); }); },
	"webpack/sharing/consume/default/prop-types/prop-types?13d9": function() { return loadSingletonVersionCheckFallback("default", "prop-types", [1,15,7,2], function() { return __webpack_require__.e("node_modules_pnpm_prop-types_15_8_1_node_modules_prop-types_index_js").then(function() { return function() { return __webpack_require__("../../node_modules/.pnpm/prop-types@15.8.1/node_modules/prop-types/index.js"); }; }); }); }
};
// no consumes in initial chunks
var chunkMapping = {
	"src_bootstrap_jsx-webpack_sharing_consume_default_react-dom_react-dom-webpack_sharing_consume-c0d0cf": [
		"webpack/sharing/consume/default/react/react?475e",
		"webpack/sharing/consume/default/react-dom/react-dom",
		"webpack/sharing/consume/default/react-router-dom/react-router-dom",
		"webpack/sharing/consume/default/dayjs/dayjs",
		"webpack/sharing/consume/default/react/react?25fe"
	],
	"webpack_sharing_consume_default_react_react": [
		"webpack/sharing/consume/default/react/react?e6fd"
	],
	"webpack_sharing_consume_default_prop-types_prop-types-webpack_sharing_consume_default_prop-ty-5d2b1f": [
		"webpack/sharing/consume/default/react/react?4b27",
		"webpack/sharing/consume/default/prop-types/prop-types?cdb3",
		"webpack/sharing/consume/default/react/react?9262",
		"webpack/sharing/consume/default/prop-types/prop-types?acfd"
	],
	"src_work_platform_top_nav_jsx": [
		"webpack/sharing/consume/default/classnames/classnames"
	],
	"src_work_platform_dashboard_home_index_jsx-webpack_sharing_consume_default_prop-types_prop-ty-b9d8d3": [
		"webpack/sharing/consume/default/react/react?8eed",
		"webpack/sharing/consume/default/prop-types/prop-types?13d9"
	]
};
__webpack_require__.f.consumes = function(chunkId, promises) {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach(function(id) {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			var onFactory = function(factory) {
				installedModules[id] = 0;
				__webpack_require__.m[id] = function(module) {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			var onError = function(error) {
				delete installedModules[id];
				__webpack_require__.m[id] = function(module) {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
		});
	}
}